import { api, uploadWithProgress, type AssetDto, type UploadSlotDto } from "../api/client";

export type AssetKind = "image" | "audio" | "document";

export function kindOf(file: Blob): AssetKind {
  if (file.type.startsWith("audio/")) return "audio";
  if (file.type === "application/pdf") return "document";
  return "image";
}

/** Dreistufiger Upload: Slot anlegen → Inhalt mit Fortschritt → Abschluss (serverseitige Prüfung). */
export async function uploadAsset(file: Blob, fileName: string, onProgress: (f: number) => void): Promise<AssetDto> {
  const slot = await api<UploadSlotDto>("/api/v1/assets/uploads", {
    body: { fileName, contentType: file.type || null, sizeBytes: file.size, kind: kindOf(file) },
  });
  if (file.size > Number(slot.maxBytes)) {
    throw new Error(`Datei zu groß (max. ${Math.round(Number(slot.maxBytes) / 1024 / 1024)} MB).`);
  }
  await uploadWithProgress(slot.uploadUrl, file, onProgress);
  return api<AssetDto>(slot.completeUrl, { method: "POST", body: {} });
}

export const rejectText = (code: string | null | undefined): string =>
  ({
    unsupported_type: "Dateityp wird nicht unterstützt.",
    heic_not_supported: "HEIC-Fotos werden auf diesem Server nicht unterstützt. Bitte als JPEG teilen (iPhone: Einstellungen › Kamera › Formate › „Maximale Kompatibilität“).",
    image_too_many_pixels: "Das Bild ist zu groß (Pixelanzahl).",
    image_decode_failed: "Das Bild konnte nicht gelesen werden.",
    file_too_large: "Die Datei ist zu groß.",
  })[code ?? ""] ?? `Datei abgelehnt (${code ?? "unbekannt"}).`;
